import {
  FORCE_ORDER_STATUS_FETCHING,
  FORCE_ORDER_STATUS_SUCCESS,
  FORCE_ORDER_STATUS_FAILURE,
  FORCE_ORDER_EIRCODE_FETCHING,
  FORCE_ORDER_EIRCODE_SUCCESS,
  FORCE_ORDER_EIRCODE_FAILURE,
  FORCE_ORDER_MISSION_NULL_FETCHING,
  FORCE_ORDER_MISSION_NULL_SUCCESS,
  FORCE_ORDER_MISSION_NULL_FAILURE,
  COMPLETE_MISSION_FETCHING,
  COMPLETE_MISSION_SUCCESS,
  COMPLETE_MISSION_FAILURE
} from 'actions/actionTypes';

const defaultState = {
  aircraft: [],
  parts: { list: [], byId: {} },
  assemblies: { list: [], byId: {} },
  newAircraft: null,
  types: []
};

export const devReducer = (state = defaultState, action) => {
  switch (action.type) {
    case FORCE_ORDER_STATUS_FETCHING: {
      return {
        ...state,
        isFetchingForceOrderStatus: true
      };
    }
    case FORCE_ORDER_STATUS_SUCCESS: {
      return {
        ...state,
        isFetchingForceOrderStatus: false
      };
    }
    case FORCE_ORDER_STATUS_FAILURE: {
      return {
        ...state,
        isFetchingForceOrderStatus: false
      };
    }
    case FORCE_ORDER_EIRCODE_FETCHING: {
      return {
        ...state,
        isFetchingForceEircodeStatus: true
      };
    }
    case FORCE_ORDER_EIRCODE_SUCCESS: {
      return {
        ...state,
        isFetchingForceEircodeStatus: false
      };
    }
    case FORCE_ORDER_EIRCODE_FAILURE: {
      return {
        ...state,
        isFetchingForceEircodeStatus: false
      };
    }
    case FORCE_ORDER_MISSION_NULL_FETCHING: {
      return {
        ...state,
        isFetchingForceOrderMissionNull: true
      };
    }
    case FORCE_ORDER_MISSION_NULL_SUCCESS: {
      return {
        ...state,
        isFetchingForceOrderMissionNull: false
      };
    }
    case FORCE_ORDER_MISSION_NULL_FAILURE: {
      return {
        ...state,
        isFetchingForceOrderMissionNull: false
      };
    }
    case COMPLETE_MISSION_FETCHING: {
      return {
        ...state,
        isFetchingCompleteMission: true
      };
    }
    case COMPLETE_MISSION_SUCCESS: {
      return {
        ...state,
        isFetchingCompleteMission: false
      };
    }
    case COMPLETE_MISSION_FAILURE: {
      return {
        ...state,
        isFetchingCompleteMission: false
      };
    }

    default:
      return state;
  }
};
